import { render } from "./ImConfirm.vue?vue&type=template&id=9ae60cd6"
import script from "./ImConfirm.vue?vue&type=script&lang=js"
export * from "./ImConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__